export default __webpack_public_path__ + "static/media/juegoconstancias_instrucciones.b8313296.png";